import {IBaseFetchOptions, IBaseParameters, IBaseResponse, IEndpointsMap} from '../ICustomApiConfig';

export const endpointsMap: IEndpointsMap = {
	GET_SUGGESTIONS: {
		path: 'suggestions',
		method: 'GET'
	}
};

export interface IGetSuggestionsOptions extends IBaseFetchOptions {
	parameters: IBaseParameters & {
		c_postalCode: string;
		c_countryCode: string;
		c_languageCode: string;
	};
}

export interface IGetSuggestionsResponse extends IBaseResponse {
	addressSuggestions: Array<{
		address: string;
		postalCode: string;
		city: string;
		countryCode: string;
	}>;
}
